import React, { useMemo, useCallback } from "react";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";

const BotonesLE = React.memo(
  ({
    rowData,
    translations,
    onAprobar,
    onCargar,
    onVer,
    onEliminar,
    showMessage,
  }) => {
    const estado = rowData.sNombreEstadoPedido;

    const handleCargar = useCallback(() => {
      if (!["CREADO", "LE_OK"].includes(estado)) {
        showMessage(
          "warn",
          translations.accionnopermitida,
          translations.pedidonopuedesereditado,
        );
        return;
      }
      onCargar(rowData);
    }, [estado, onCargar, rowData, showMessage, translations]);

    const handleAprobar = useCallback(() => {
      if (!["LE_OK", "LE_APROBADA"].includes(estado)) {
        showMessage(
          "error",
          translations.estadoincorrecto,
          translations.pedidodebeserleok,
        );
        return;
      }

      console.log("✅ Estado válido: ejecutando onAprobar");
      onAprobar(rowData);
    }, [estado, rowData, onAprobar, showMessage, translations]);

    const handleVer = useCallback(() => {
      if (estado === "CREADO") {
        showMessage(
          "error",
          translations.estadoincorrecto,
          translations.pedidosinlistaempaque,
        );
        return;
      }
      onVer(rowData);
    }, [estado, onVer, rowData, showMessage, translations]);

    const handleEliminar = useCallback(() => {
      if (estado === "CREADO") {
        showMessage(
          "error",
          translations.estadoincorrecto,
          translations.pedsinlistadeempaque,
        );
        return;
      }
      if (!["LE_APROBADA", "LE_OK", "CREADO"].includes(estado)) {
        showMessage(
          "error",
          translations.estadoincorrecto,
          translations.le_nopuedeserelim,
        );
        return;
      }

      confirmDialog({
        message: translations.preg_eliminar_le_pedido,
        header: translations.text_Confirmacion,
        icon: "pi pi-question-circle",
        acceptClassName: "p-button-primary",
        rejectClassName: "p-button-outlined",
        acceptLabel: translations.yesbutton,
        rejectLabel: translations.nobutton,
        className: "confirm-dialog-small",
        style: { width: "450px" },
        accept: () => onEliminar(rowData),
        reject: () =>
          showMessage(
            "info",
            translations.accioncancelada,
            translations.accioncancelada,
          ),
      });
    }, [estado, rowData, onEliminar, showMessage, translations]);

    const botones = useMemo(
      () => (
        <div
          style={{
            display: "flex",
            gap: "2px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            id={`le-btn-cargar-${rowData.idpedido}`}
            icon="pi pi-arrow-up"
            className="p-button-rounded p-button-info btn-accion-tabla"
            tooltip={translations.tooltip_Cargar}
            tooltipOptions={{ position: "top" }}
            onClick={handleCargar}
          />
          <Button
            id={`le-btn-aprobar-${rowData.idpedido}`}
            icon="pi pi-check-circle"
            className="p-button-rounded p-button-info btn-accion-tabla"
            tooltip={translations.tooltip_Aprobar}
            tooltipOptions={{ position: "top" }}
            onClick={handleAprobar}
          />
          <Button
            id={`le-btn-ver-${rowData.idpedido}`}
            icon="pi pi-eye"
            className="p-button-rounded p-button-info btn-accion-tabla"
            tooltip={translations.tooltip_Ver}
            tooltipOptions={{ position: "top" }}
            onClick={handleVer}
          />
          <Button
            id={`le-btn-eliminar-${rowData.idpedido}`}
            icon="pi pi-trash"
            className="p-button-rounded p-button-info btn-accion-tabla"
            tooltip={translations.tooltip_Eliminar}
            tooltipOptions={{ position: "top" }}
            onClick={handleEliminar}
          />
        </div>
      ),
      [
        handleCargar,
        handleAprobar,
        handleVer,
        handleEliminar,
        translations,
        rowData.idpedido,
      ],
    );

    return botones;
  },
);

export default React.memo(BotonesLE);
